import {useWishlistStore} from '~/stores';
import type {IWishlistPayload} from '~/utils/services/api/account/wishlists/wishlists';
import type {IWishlist} from '~/types';

export const getDefaultList = (wishlists: IWishlist[] | null) => wishlists ? wishlists.find((wishlist) => wishlist.isDefault) : undefined;
export const getIsProductInList = (wishlist: IWishlist, productId: string) => wishlist.articles.find((article) => article.id === productId);

const setListToEdit = (wishlist: IWishlist) => useWishlistStore().setEditList(
    {
        id: wishlist.id,
        title: wishlist.title,
        description: wishlist.description,
        isDefault: wishlist.isDefault,
    },
);

const create = async (payload: IWishlistPayload) => {
    const {data, error} = await useCreateWishlist({...payload, ...{default: true}});
    if (data.value) {
        // Set new list as edit list
        setListToEdit(data.value);
        return data.value && !error.value;
    }
    return false;
};

export const createWishlistAction = async (payload: IWishlistPayload, productId: string | undefined = undefined) => {
    const created = await create(payload);
    if (created) {
        await useUpdateWishlist({...payload, ...{default: true, articleId: productId, amount: 1}});
    }
    // As this functionality is based on OPTIMISTIC UI, we'll always return successful status
    return payload.title;
};

export const manageProductInWishlistAction = async (wishlist: IWishlist, productId: string, remove = false) => {
    setListToEdit(wishlist);
    const payload = {
        title: wishlist.title,
        description: wishlist.description,
        default: wishlist.isDefault,
        articleId: productId,
        amount: remove ? 0 : 1,
    };
    const {data: updatedList} = await useUpdateWishlist(payload);
    if (updatedList.value) {
 useWishlistStore().setLastAction(remove ? 'deleteList' : 'addProduct', updatedList.value, productId);
}
    return wishlist.title;
};
